import React from "react";
import "./MessageCodes.css";

const MessageA3F = (props) => {
  return (
    <div style={{ width: "fit-content" }}>
      <div
        className={
          !props.disable
            ? "chat-text"
            : "chat-labelnohover"
        }
        id="main-tab1"
        style={{ color: props.disable && "grey" }}
        dangerouslySetInnerHTML={{ __html: props.item.text }}
      >
      </div>
    </div>
  );
};

export default MessageA3F;
